import { getModKey } from 'Pages/lettersetup/helpers/Editor';

export const TOAST_HANG_TIME = 5;
export const TOAST_Z_INDEX = 10000;
export const COLUMN_RESPONSIVE_WIDTH_WIDESCREEN = 10;
export const COLUMN_RESPONSIVE_WIDTH_COMPUTER = 16;
export const COLUMN_RESPONSIVE_WIDTH_LARGESCREEN = 10;

export const HIDE_HEADER_LOCATIONS = ['/pointofsale', '/managemenu/edit'];
export const HIDE_SIDEBAR_LOCATIONS = [
  '/pointofsale',
  '/managemenu/edit',
  '/manageproduction/edit',
];

export { default as FALLBACK_IMAGE } from 'Styles/fallback.png';
export { default as PENDO_ICON } from 'Styles/pendo-icon.png';

export const ALL_OPTION = 'All';

export const Y = 'Y';
export const N = 'N';

/** Yes, No Bit */
export const Y_N_BIT = {
  Y,
  N,
};

/** ⌘ for Mac, Ctrl otherwise */
export const MOD_KEY = getModKey();



// WEBPACK FOOTER //
// ./src/common/Constants/ui.js